import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  { path: ':city/:page', component: HomeComponent },
  { path: ':city', component: HomeComponent },
  { path: '', redirectTo: '/sao-joao-da-boa-vista', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
